import { useEffect, useState } from "react";

/**
 * Debounce function for delayed filter change
 * @param callback Function which changes filter
 * @param initialValue InitialValue
 * @param customDelay Custom delay in milliseconds
 */
export function useDebounce(
  callback: (value: string) => void,
  initialValue: string,
  customDelay?: number
) {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    const delay = customDelay || 500;
    const timer = setTimeout(() => {
      callback(value);
    }, delay);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return [value, setValue] as const;
}
